var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.taxonomy
    ? _c(
        "div",
        {
          class: [
            _vm.attribute
              ? "svea-product__metadata-data"
              : "svea-product__taxonomies-taxonomy",
          ],
        },
        [
          _vm._v("\n  " + _vm._s(_vm.taxonomy.label) + ":\n  "),
          _vm._l(_vm.taxonomy.values, function (value, index) {
            return _c(
              "a",
              {
                key: value.term_id,
                attrs: { href: _vm.taxonomyUrl(_vm.taxonomy, index) },
              },
              [_vm._v("\n    " + _vm._s(value.name) + "\n  ")]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/DisplayTaxo.vue